module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/report-packages-5470627635b206e37cbaad526d73bf3b.svg";